const defaultsTo = (object, field, defaultValue) => (
  object && object[field] !== undefined
    ? object[field]
    : defaultValue
);
export default defaultsTo;
